(function (angular) {
	'use strict';
	
	var surveyObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		controller: [
			'urlFactory',
			SurveyFunction
		],
		controllerAs: 'survey'
	};
	
	angular
		.module('baseCheckoutModule')
		.component('postConversionSurveyComponent', surveyObject);
	
	function templateUrlFunction(
		STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/checkout/survey.html';
	}
	
	function SurveyFunction(
		urlFactory) {
		
		var survey = this;
		
		survey.submitSurvey = function() {
			if(survey.answer) {
				var url = "/api-secured/hdyh-survey";
				var data = {answer: survey.answer};
				survey.formSubmitted = true;
				return urlFactory.apiPostPromise(url, data)
					.then(function () {
						survey.success = true;
					})
					.catch(function (response) {
						survey.formSubmitted = false;
						urlFactory.handledFailedRequest(response);
					});
			}
			else {
				survey.attemptSubmit = true;
			}
		};
		
	}
})(window.angular);
